import { render, staticRenderFns } from "./PxCamposCompraItemTableSankhya.vue?vue&type=template&id=2bc619f2&"
import script from "./PxCamposCompraItemTableSankhya.vue?vue&type=script&lang=js&"
export * from "./PxCamposCompraItemTableSankhya.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports